import { LoadableAfterPaint } from '@confluence/loadable';

export const RequestAccessPopupComponent = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GrantAccessDialog" */ './RequestAccessPopup'))
			.RequestAccessPopupComponent,
});
